
import { Component, Vue } from 'vue-property-decorator';

import { BaseText } from '@warrenbrasil/nebraska-web';
import { HomeWidget } from '@/modules/home/components/HomeWidget';
import { HomeWidgetLoader } from '@/modules/home/components/HomeWidgetLoader';
import { StatementsList } from './components/StatementsList';

import { getStatements, HomeStatement } from '@/modules/home/services/bff';
import { WarrenModules } from '@/types/navigation';
import * as trackEvents from './track-events';

@Component({
  components: {
    BaseText,
    HomeWidget,
    HomeWidgetLoader,
    StatementsList
  }
})
export default class HomeStatements extends Vue {
  readonly module = WarrenModules.Home;
  statements: HomeStatement[] = [];
  hasError = false;
  isLoading = true;

  created() {
    this.fetchStatements();
  }

  reloadStatements() {
    this.fetchStatements();
    trackEvents.trackReloadTransactionErrorClick();
  }

  get hasStatements() {
    return this.statements.length > 0;
  }

  async fetchStatements() {
    this.isLoading = true;
    this.hasError = false;

    try {
      const { items } = await getStatements();
      this.statements = items;
    } catch {
      this.hasError = true;
      trackEvents.trackTransactionErrorLoad();
    } finally {
      this.isLoading = false;
    }
  }
}
